import { Icon } from '@/components/Icon/Icon';
import { Skeleton } from '@/components/Skeleton/Skeleton';
import Logo from '@/public/img/pitch/1k5_logo.svg';
import React from 'react';

export const PageSkeleton = () => (
  <div className="relative flex h-screen bg-colors-backgrounds-secondary">
    <nav className="h-screen w-2000 shrink-0 border-r border-colors-borders-secondary bg-colors-backgrounds-glass-low-transparent px-400 py-800">
      <div className="flex h-full flex-col items-center gap-400">
        <div
          className="block p-200 opacity-60"
          aria-label="Loading navigation"
          aria-disabled="true"
        >
          <span className="block size-[3rem] overflow-hidden rounded-100">
            <Logo className="w-full" />
          </span>
        </div>

        <Skeleton className="mt-200 h-1000 w-1000 rounded-100" />
        <Skeleton className="mb-200 mt-auto h-1200 w-1200 rounded-max" />
      </div>
    </nav>
    <div className="absolute inset-0 flex items-center justify-center">
      <div
        className="flex items-center justify-center"
        role="status"
        aria-label="Loading"
      >
        <Icon className="h-2400 w-2400" icon="Loading" animation="spin" />
      </div>
    </div>
  </div>
);
